// src/locales/ta/messageCenterShiftTypes.js
export const messageCenterShiftTypes = {
  pageTitle: 'செய்தி மைய ஷிப்ட் வகைகள்',
  pageDescription: 'ஷிப்ட் வகைகளையும் அவற்றின் கமிஷன் ஸ்லாப்களையும் நிர்வகிக்கவும்',
  newShiftType: 'புதிய ஷிப்ட் வகை',
  editShiftType: 'ஷிப்ட் வகையைத் திருத்து',
  createShiftType: 'ஷிப்ட் வகை உருவாக்கு',
  saveShiftType: 'ஷிப்ட் வகையைச் சேமி',
  name: 'பெயர்',
  defaultTimes: 'இயல்புநிலை நேரங்கள்',
  defaultStartTime: 'இயல்புநிலை தொடக்க நேரம்',
  defaultEndTime: 'இயல்புநிலை முடிவு நேரம்',
  commissionMethod: 'கமிஷன் முறை',
  commissionMethodHelp: 'தற்போது விற்பனை மதிப்பு அடிப்படையில் மட்டுமே கிடைக்கும். ஆர்டர்/உருப்படி அடிப்படையிலானது பின்னர் சேர்க்கப்படும்.',
  defaultTarget: 'இயல்பான இலக்கு',
  defaultTargetHelp: 'இந்த ஷிப்ட் வகையின் புதிய ஷிப்டுகளுக்குப் பயன்படுத்தப்படும் இயல்பான விற்பனை இலக்கு.',
  perSalesValue: 'விற்பனை மதிப்பு அடிப்படையில்',
  commissionSlabs: 'கமிஷன் ஸ்லாப்கள்',
  noSlabsConfigured: 'ஸ்லாப்கள் அமைக்கப்படவில்லை',
  addSlab: 'ஸ்லாப் சேர்',
  removeSlab: 'அகற்று',
  minValue: 'குறைந்தபட்ச மதிப்பு',
  maxValue: 'அதிகபட்ச மதிப்பு',
  rate: 'விகிதம் (%)',
  openEnded: 'திறந்த முடிவு',
  slabsHelp: 'கடைசி ஸ்லாப் திறந்த முடிவைக் கொண்டிருக்க வேண்டும் (அதிகபட்ச மதிப்பு இல்லை). ஸ்லாப்கள் மேலெழுதப்படக்கூடாது.',
  failedToLoadShiftTypes: 'ஷிப்ட் வகைகளை ஏற்ற முடியவில்லை',
  shiftTypeCreatedSuccess: 'ஷிப்ட் வகை வெற்றிகரமாக உருவாக்கப்பட்டது',
  shiftTypeUpdatedSuccess: 'ஷிப்ட் வகை வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  failedToSaveShiftType: 'ஷிப்ட் வகையை சேமிக்க முடியவில்லை',
  noShiftTypesYet: 'இன்னும் ஷிப்ட் வகைகள் இல்லை',
  noShiftTypesYetDescription: 'தொடங்க உங்கள் முதல் ஷிப்ட் வகையை உருவாக்கவும்',
  edit: 'திருத்து',
  activeHelp: 'Inactive shift types cannot be used for new shifts',
  placeholders: {
    name: 'e.g. Day Shift',
    selectTime: 'Select time',
    defaultTarget: 'e.g. 500000',
    firstMin: '0',
    nextMin: 'e.g. {value}',
    maxValue: 'e.g. 6000',
    rate: 'e.g. 1.5',
    fixedAmount: 'e.g. 5000',
  },
  validation: {
    nameRequired: 'பெயர் தேவை',
    startTimeRequired: 'இயல்புநிலை தொடக்க நேரம் தேவை',
    endTimeRequired: 'இயல்புநிலை முடிவு நேரம் தேவை',
    slabMinValueInvalid: 'குறைந்தபட்ச மதிப்பு சரியான எதிர்மறையற்ற எண்ணாக இருக்க வேண்டும்',
    slabRateInvalid: 'விகிதம் சரியான எதிர்மறையற்ற எண்ணாக இருக்க வேண்டும்',
    slabMaxValueRequired: 'கடைசியைத் தவிர ஒவ்வொரு ஸ்லாப்பிற்கும் அதிகபட்ச மதிப்பு தேவை',
    minNegative: 'Min value cannot be negative',
    maxNegative: 'Max value must be a valid non-negative number',
    wholeNumber: 'Use a whole number (no decimals)',
    maxRequired: 'Max value is required when another slab follows',
    maxGreater: 'Max value must be greater than min value',
    outOfOrder: 'Slabs must be in ascending order — this slab must start at {value}',
    gap: 'Slabs cannot have gaps — this slab must start at {value}',
    lastOpenEnded: 'The last (highest) slab must be open-ended — clear its max value',
    rateNegative: 'Value cannot be negative',
    rateRequired: 'Enter a valid non-negative value',
    rateMax: 'Rate cannot exceed 100%',
    fixErrors: 'சேமிப்பதற்கு முன் குறிப்பிடப்பட்ட பிழைகளை சரிசெய்யவும்',
  },
};
